import { adsEn } from "./ads.en.ts";
import { translate, type Translation } from "./lang.ts";

/**
 * Rewarded ads, the gift chest and privacy in the Google Play app. Same house
 * style as vi.ts: warm and plain, no dashes, dots, slashes, symbols or
 * parentheses. Ads are always the player's choice, so the copy says what
 * they get and never nags. English twin in `ads.en.ts`.
 */
const source = {
  calling: "Đang gọi quảng cáo tới, chờ xíu nha",
  unavailable: "Quảng cáo đang đi vắng xíu, lát nữa thử lại nha.",
  skipped: "Xem chưa hết nên quà chưa tới rồi. Lần sau xem trọn nha!",
  needNetwork: "Bắt mạng giúp tụi mình rồi xem quảng cáo nha.",
  hint: {
    watch: "Xem quảng cáo nhận gợi ý",
    note: "Một quảng cáo ngắn đổi lấy một gợi ý, khỏi tốn đồng vàng nào.",
    or: "Hoặc trả bằng vàng",
    got: "Gợi ý tới rồi nè, xài liền nha!",
  },
  double: {
    watch: (gold: number) => `Xem quảng cáo nhận thêm ${gold} vàng`,
    got: (gold: number) => `Ting ting! Thêm ${gold} vàng bay vào ví rồi nè!`,
    later: "Vàng thưởng đang trên đường bay về ví, bạn cứ chơi tiếp nha.",
    already: "Màn này nhận thưởng thêm rồi nha.",
  },
  gift: {
    label: "Rương quà",
    title: "Rương quà mỗi ngày",
    body: (gold: number) => `Xem một quảng cáo ngắn là mở được rương, rinh ${gold} vàng về ví liền.`,
    left: (n: number, total: number) => `Hôm nay còn ${n} trên ${total} rương`,
    open: "Xem quảng cáo, mở rương",
    empty: "Hôm nay mở hết rương rồi. Mai ghé lại có rương mới nha!",
    got: (gold: number) => `Rương mở toang! Bạn rinh được ${gold} vàng!`,
    later: "Rương mở rồi, vàng sẽ vào ví sau xíu nha.",
    close: "Để sau",
    done: "Tuyệt vời!",
  },
  privacy: {
    title: "Quyền riêng tư",
    adChoices: "Quyền riêng tư quảng cáo",
    policy: "Chính sách quyền riêng tư",
    deleteOpen: "Xóa dữ liệu của tôi",
    deleteTitle: "Xóa dữ liệu của bạn",
    deleteBody:
      "Xóa vĩnh viễn hồ sơ của bạn trên máy chủ, gồm tiến độ, vàng, đồ đã mua, tên trên bảng xếp hạng và mã khôi phục. Máy này cũng sẽ bắt đầu lại từ đầu.",
    deleteSure: "Chắc chắn chưa nè? Xóa rồi là không lấy lại được đâu đó.",
    deleteYes: "Xóa vĩnh viễn",
    deleteNo: "Thôi, giữ lại",
    deleteNeedNetwork: "Cần mạng để xóa dữ liệu trên máy chủ nha.",
    deleteFailed: "Chưa xóa được, thử lại sau xíu nha.",
    updates: "Game tự cập nhật qua Google Play nha.",
  },
};

export type AdsStrings = Translation<typeof source>;

export const adsVi: AdsStrings = translate(source, adsEn);
